export default __webpack_public_path__ + "static/media/ticket.62dfbbae.png";